export const environment = {
  production: true,
  APIUrl: 'https://dct-apim.azure-api.net/Checklist',
  // APIUrl: 'http://197.44.255.10:4423',
  PublicAuthUrl: 'https://dct-apim.azure-api.net/check_list',
  LoginScreen: 'https://frontend-dct.azurewebsites.net/Account/LogOff',
  syncfusionLicense:
    'Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1ecnRSRGhZV0Z2WkU=',
};